export const mapSingleAddressData = address => {
  const { streetNumber, streetName, zipcode, city, meterData } = address
  const secondMeterData = (meterData?.additionalMeters ?? []).find(meter => meter.meterType === 'electricity')
  const label = (streetNumber ?? '') + ' ' + (streetName ?? '') + ' ' + (zipcode ?? '') + ' ' + (city ?? '')

  const electricityMeter = meterData?.electricityMeter
    ? {
        id: meterData.electricityMeter.id,
        pdlNo: meterData.electricityMeter.pdlNo,
        meterSerialNumber: meterData.electricityMeter.meterSerialNumber,
        gridOperator: meterData.electricityMeter.gridOperator,
        pdlEligibilityData: meterData.electricityMeter.pdlEligibilityData,
        oldOccupant: meterData.electricityMeter.oldOccupant,
        validationWarnings: meterData.electricityMeter.validationWarnings || {},
        isValidPdl: !!meterData.electricityMeter.pdlNo,
        enedisAuth: meterData.electricityMeter.consentDate !== null,
        consentDate: meterData.electricityMeter.consentDate,
      }
    : {}

  const electricityMeter2 = secondMeterData
    ? {
        id: secondMeterData.id,
        pdlNo: secondMeterData.meterNumber,
        meterSerialNumber: secondMeterData.meterSerialNumber,
        isValidPdl: !!secondMeterData.meterNumber,
      }
    : {}

  const gasMeter = meterData?.gasMeter
    ? {
        id: meterData.gasMeter.id,
        pceNo: meterData.gasMeter.pceNo,
        meterSerialNumber: meterData.gasMeter.meterSerialNumber,
        gridOperator: meterData.gasMeter.gridOperator,
        pceEligibilityData: meterData.gasMeter.pceEligibilityData,
        isValidPce: meterData.gasMeter.isValidPce || !!meterData.gasMeter.pceNo,
        validationWarnings: meterData.gasMeter.validationWarnings || {},
        meterConsent: meterData.gasMeter.consentDate !== null,
        consentDate: meterData.gasMeter.consentDate,
      }
    : {}

  return {
    label: label.trim(),
    ...address,
    energyLandscape: address.energyLandscape ?? {},
    buildingPermitData: address.buildingPermitData ?? {},
    lastHolderData: address.lastHolderData ?? {},
    cadastralData: address.cadastralData ?? {},
    electricityMeter,
    electricityMeter2,
    gasMeter,
    hasElectricityMeter: meterData?.hasElectricityMeter || false,
    hasGasMeter: meterData?.hasGasMeter || false,
  }
}
